<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container py-3" *ngIf="receiptDetail">
    <div *ngIf="isEdit">
        <button *ngIf="receiptDetail.STATUS === 'Done'" class="btn btn-outline-danger"
            style="position: absolute; right: 3%;" (click)="cancel(id)">
            ยกเลิกใบเสร็จ
        </button>
    </div>

    <h1 class="text-center lifedi-color m-3">
        <span *ngIf="isEdit">แก้ไขใบเสร็จ</span>
        <span *ngIf="!isEdit">สร้างใบเสร็จ</span>
    </h1>

    <div class="row d-flex justify-content-center">
        <div class="btn-group m-4" role="group" aria-label="Basic example">
            <button type="button" [ngClass]="createType === 'Short' ? 'btn-active' : 'btn-inactive'"
                class="btn btn-left" (click)="change('Short')">ใบเสร็จอย่างย่อ</button>
            <button type="button" [ngClass]="createType === 'Full' ? 'btn-active' : 'btn-inactive'"
                class="btn btn-right" (click)="change('Full')">ใบเสร็จเต็มรูปแบบ</button>
        </div>
    </div>

    <div class="row d-flex">
        <div class="col-12 col-md-8">
            <p class="text-left mt-3">
                <b>หมายเลขเอกสารใบเสนอราคา {{ id }} </b>
            </p>
        </div>
    </div>

    <div class="row d-flex justify-content-center">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="p-3" style="width: 100%;">
                <div *ngIf="createType === 'Short'">
                    <div class="row justify-content-end px-3" [ngClass]="{'disable-display': printType === 'Full'}">
                        <button *ngIf="receiptForm.valid" (click)="print(receiptForm.value)" mat-button
                            class="print-btn mx-3">
                            <img src="assets/printer.png" alt="print">
                        </button>
                        <button *ngIf="!receiptForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                            <img src="assets/printer.png" alt="print">
                        </button>
                    </div>

                    <div class="disable-display">
                        <form [formGroup]="receiptForm">
                            <div class="row d-flex justify-content-center my-4">
                                <div *ngFor="let col of column; let i = index" [class]="col.class">
                                    <p class="text-center">
                                        <b>{{col.header}}</b>
                                        <span *ngIf="i !== 0 && i !== column.length - 1">
                                            <lifedi-require></lifedi-require>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div *ngFor="let w of receiptForm.get('lists')['controls']; let i = index"
                                formArrayName="lists" class="my-3">
                                <div class="row d-flex justify-content-center" [formGroupName]="i">
                                    <div class="col-1">
                                        <p class="text-center">{{ i + 1 }}</p>
                                    </div>
                                    <div class="col-4 pl-0">
                                        <textarea class="form-control" formControlName="list" rows="3"
                                            (keyup)="onCreateGroupFormValueChange()"></textarea>
                                    </div>
                                    <div class="col-1 p-0">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="number"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryAbbreviated(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['number'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-2">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="unitPrice"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryAbbreviated(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['unitPrice'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-1 p-0">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="discount"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryAbbreviated(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['discount'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-2">
                                        <p class="text-center">
                                            <b>{{ receiptFormArray.value[i].total | number : '1.2-2' }} บาท</b>
                                        </p>
                                    </div>
                                    <div class="col-1">
                                        <img *ngIf="receiptFormArray.value.length > 1" src="assets/close.png"
                                            class="img" style="width: 30px; height: 30px; cursor: pointer;"
                                            (click)="removeGroup(i, receiptForm)">
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="row justify-content-center">
                            <img src="assets/add.png" class="img my-4"
                                style="width: 30px; height: 30px; cursor: pointer;" (click)="addGroup('Short')">
                        </div>
                    </div>
                    <div class="container px-4 py-4">
                        <div [ngClass]="isEdit ? 'disable-display' : ''" class="row d-flex justify-content-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <form [formGroup]="receiptForm">
                                    <label for="note" class="form-label">หมายเหตุ</label>
                                    <textarea class="form-control" id="note" formControlName="note" rows="5"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </form>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="row disable-display">
                                    <div class="col-6">
                                        <p class="text-left">รวมเงิน</p>
                                        <p class="text-left text-danger">ส่วนลด</p>
                                        <p class="text-left">ราคาไม่รวมภาษีมูลค่าเพิ่ม</p>
                                        <mat-checkbox id="vat" [ngClass]="vat ? '' : 'text-secondary'" [(ngModel)]="vat"
                                            (change)="calNetPriceAbbreviated()" class="form-control-plaintext p-0">
                                            ภาษีมูลค่าเพิ่ม (7%)
                                        </mat-checkbox>
                                        <h5 class="text-left text-primary mt-4">รวมราคาสุทธิ</h5>
                                    </div>
                                    <div class="col-6">
                                        <p class="text-right">{{ total | number : '1.2-2' }} บาท</p>
                                        <p class="text-right text-danger">{{ discount | number : '1.2-2' }} บาท</p>
                                        <p class="text-right">{{ priceWithoutVat | number : '1.2-2' }} บาท</p>
                                        <p class="text-right" [ngClass]="vat ? '' : 'text-secondary'">
                                            {{ vatPrice | number : '1.2-2' }} บาท
                                        </p>
                                        <h5 class="text-right text-primary" style="margin-top: 36px;">
                                            {{ totalNetPrice | number : '1.2-2' }} บาท</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="invoiceType === 'Partial'" class="container">
                        <hr width="100%">
                        <form [formGroup]="receiptForm">
                            <div class="form-group row justify-content-center my-4">
                                <label for="installmentType" class="col-form-label col-1 text-right">แบ่งชำระ</label>
                                <div class="col-2">
                                    <select class="custom-select form-control" style="display: inline;" disabled>
                                        <option selected>
                                            ตามจำนวนเงิน
                                        </option>
                                        <!-- <option *ngFor="let s of installmentList" [id]="s.value" [value]="s.value">
                                            {{ s.label }}
                                        </option> -->
                                    </select>
                                </div>
                                <div class="col-1">
                                    <!-- <label *ngIf="receiptForm.value.type === 'percent'" for="installmentType"
                                        class="col-form-label text-right">เปอร์เซ็นต์</label> -->
                                </div>
                                <div class="col-2">
                                    <!-- <input *ngIf="receiptForm.value.type === 'percent'" type="number"
                                        class="form-control" formControlName="percent"> -->
                                </div>
                                <label for="installmentType" class="col-form-label col-1 text-right">จำนวนเงิน</label>
                                <div class="col-2">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="total"
                                        (ngModelChange)="detectNumber($event, receiptForm.controls['total'])"
                                        [nzFormatter]="formatterPrice" nzDisabled>
                                    </nz-input-number>
                                </div>
                                <label for="installmentType" class="col-form-label col-1">บาท</label>
                            </div>
                            <div class="row justify-content-center mt-3">
                                <div class="col-5"></div>
                                <div class="col-2">
                                    <p class="text-right">จำนวนเงินทั้งสิ้น</p>
                                </div>
                                <div class="col-2">
                                    <p class="text-right">{{ receiptForm.value.total | number : '1.2-2'}}</p>
                                </div>
                                <div class="col-1">
                                    <p class="text-left">บาท</p>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>

                <div *ngIf="createType === 'Full'">
                    <div class="row justify-content-end px-3" [ngClass]="{'disable-display': printType === 'Short'}">
                        <button *ngIf="receiptForm.valid" (click)="print(receiptForm.value)" mat-button
                            class="print-btn mx-3">
                            <img src="assets/printer.png" alt="print">
                        </button>
                        <button *ngIf="!receiptForm.valid" mat-button class="print-btn-disable mx-3" disabled>
                            <img src="assets/printer.png" alt="print">
                        </button>
                    </div>
                    <form [formGroup]="receiptForm">
                        <div [ngClass]="isEdit ? 'disable-display' : ''" class="row justify-content-center px-3">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label for="courseType" class="form-label">
                                        ชื่อลูกค้า<lifedi-require></lifedi-require>
                                    </label>
                                    <input type="text" class="form-control" formControlName="name" readonly>
                                </div>
                                <div class="form-group">
                                    <label for="detail" class="form-label">
                                        ข้อมูลลูกค้า<lifedi-require></lifedi-require>
                                    </label>
                                    <textarea class="form-control" id="detail" formControlName="detail" rows="5"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label for="title" class="form-label">
                                        หัวข้อ<lifedi-require></lifedi-require>
                                    </label>
                                    <input id="title" type="text" class="form-control" formControlName="title" readonly>
                                </div>
                                <div class="form-group">
                                    <label for="taxId" class="form-label">
                                        เลขประจำตัวผู้เสียภาษี<lifedi-require></lifedi-require>
                                    </label>
                                    <input id="taxId" type="text" class="form-control" MaxLength="13"
                                        formControlName="taxId" readonly>
                                </div>
                                <div class="form-group">
                                    <label for="date" class="form-label">
                                        วันที่<lifedi-require></lifedi-require>
                                    </label>
                                    <input id="date" class="form-control" date-format="dd-MM-yyyy HH:mm:ss"
                                        formControlName="date" (ngModelChange)="onCreateGroupFormValueChange()"
                                        [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
                                        dateFormat="dd-MM-yyyy" autocomplete="off">
                                    <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
                                </div>
                            </div>
                        </div>

                        <div class="disable-display">
                            <div class="row d-flex justify-content-center my-4">
                                <div *ngFor="let col of column; let i = index" [class]="col.class">
                                    <p class="text-center">
                                        <b>{{col.header}}</b>
                                        <span *ngIf="i !== 0 && i !== column.length - 1">
                                            <lifedi-require></lifedi-require>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div *ngFor="let w of receiptForm.get('lists')['controls']; let i = index"
                                formArrayName="lists" class="my-3">
                                <div class="row d-flex justify-content-center" [formGroupName]="i">
                                    <div class="col-1">
                                        <p class="text-center">{{ i + 1 }}</p>
                                    </div>
                                    <div class="col-4 pl-0">
                                        <textarea class="form-control" formControlName="list" rows="3"
                                            (keyup)="onCreateGroupFormValueChange()"></textarea>
                                    </div>
                                    <div class="col-1 p-0">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="number"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryFullReceipt(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['number'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-2">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="unitPrice"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryFullReceipt(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['unitPrice'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-1 p-0">
                                        <nz-input-number [nzSize]="'large'" [nzMin]="0" formControlName="discount"
                                            (ngModelChange)="getTotal(receiptFormArray, i)"
                                            (ngModelChange)="getSummaryFullReceipt(receiptFormArray)"
                                            (ngModelChange)="detectNumber($event, receiptFormArray.at(i).controls['discount'])"
                                            (ngModelChange)="onCreateGroupFormValueChange()"
                                            [nzFormatter]="formatterPrice">
                                        </nz-input-number>
                                    </div>
                                    <div class="col-2">
                                        <p class="text-center">
                                            <b>{{ receiptFormArray.value[i].total | number : '1.2-2' }} บาท</b>
                                        </p>
                                    </div>
                                    <div class="col-1">
                                        <img *ngIf="receiptFormArray.value.length > 1" src="assets/close.png"
                                            class="img" style="width: 30px; height: 30px; cursor: pointer;"
                                            (click)="removeGroup(i, receiptForm)">
                                    </div>
                                </div>
                            </div>

                            <div class="row justify-content-center">

                                <img src="assets/add.png" class="img my-4"
                                    style="width: 30px; height: 30px; cursor: pointer;" (click)="addGroup('Full')">
                            </div>
                        </div>
                    </form>

                    <div [ngClass]="isEdit ? 'disable-display' : ''" class="container px-4 py-4">
                        <div class="row d-flex justify-content-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <form [formGroup]="receiptForm">
                                    <label for="note" class="form-label">หมายเหตุ</label>
                                    <textarea class="form-control" id="note" formControlName="note" rows="5"
                                        (keyup)="onCreateGroupFormValueChange()"></textarea>
                                </form>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="row disable-display">
                                    <div class="col-6">
                                        <p class="text-left">รวมเงิน</p>
                                        <p class="text-left text-danger">ส่วนลด</p>
                                        <p class="text-left">ราคาไม่รวมภาษีมูลค่าเพิ่ม</p>
                                        <mat-checkbox id="vat" [ngClass]="vat ? '' : 'text-secondary'" [(ngModel)]="vat"
                                            (change)="calNetPriceFullReceipt()" class="form-control-plaintext p-0">
                                            ภาษีมูลค่าเพิ่ม (7%)
                                        </mat-checkbox>
                                        <h5 class="text-left text-primary mt-4">รวมราคาสุทธิ</h5>
                                    </div>
                                    <div class="col-6">
                                        <p class="text-right">{{ total2 | number : '1.2-2' }} บาท</p>
                                        <p class="text-right text-danger">{{ discount2 | number : '1.2-2' }} บาท</p>
                                        <p class="text-right">{{ priceWithoutVat2 | number : '1.2-2' }} บาท</p>
                                        <p class="text-right" [ngClass]="vat ? '' : 'text-secondary'">
                                            {{ vatPrice2 | number : '1.2-2' }} บาท
                                        </p>
                                        <h5 class="text-right text-primary" style="margin-top: 36px;">
                                            {{ totalNetPrice2 | number : '1.2-2' }} บาท</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="invoiceType === 'Partial'" class="container">
                        <hr width="100%">
                        <form [formGroup]="receiptForm">
                            <div class="form-group row justify-content-center my-4">
                                <label for="installmentType" class="col-form-label col-1 text-right">แบ่งชำระ</label>
                                <div class="col-2">
                                    <select class="custom-select form-control" style="display: inline;" disabled>
                                        <option selected>
                                            ตามจำนวนเงิน
                                        </option>
                                        <!-- <option *ngFor="let s of installmentList" [id]="s.value" [value]="s.value">
                                            {{ s.label }}
                                        </option> -->
                                    </select>
                                </div>
                                <div class="col-1">
                                    <!-- <label *ngIf="receiptForm.value.type === 'percent'" for="installmentType"
                                        class="col-form-label text-right">เปอร์เซ็นต์</label> -->
                                </div>
                                <div class="col-2">
                                    <!-- <input *ngIf="receiptForm.value.type === 'percent'" type="number"
                                        class="form-control" formControlName="percent"> -->
                                </div>
                                <label for="installmentType" class="col-form-label col-1 text-right">จำนวนเงิน</label>
                                <div class="col-2">
                                    <nz-input-number [nzSize]="'large'" [nzMin]="1" formControlName="total"
                                        (ngModelChange)="detectNumber($event, receiptForm.controls['total'])"
                                        [nzFormatter]="formatterPrice" nzDisabled>
                                    </nz-input-number>
                                </div>
                                <label for="installmentType" class="col-form-label col-1">บาท</label>
                            </div>
                            <div class="row justify-content-center mt-3">
                                <div class="col-5"></div>
                                <div class="col-2">
                                    <p class="text-right">จำนวนเงินทั้งสิ้น</p>
                                </div>
                                <div class="col-2">
                                    <p class="text-right">{{ receiptForm.value.total | number : '1.2-2'}}</p>
                                </div>
                                <div class="col-1">
                                    <p class="text-left">บาท</p>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>

            </mat-card>
        </div>
    </div>

    <div *ngIf="!isEdit" class="row justify-content-center pb-5 pt-4">
        <div *ngIf="createType === 'Full'">
            <lifedi-btn *ngIf="receiptForm.valid" lable="บันทึก" (click)="saveFullReceipt(receiptForm.value)"
                customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn *ngIf="!receiptForm.valid" lable="บันทึก" disabled="true"
                customStyle="margin: 0px; padding: 0 30px;">
            </lifedi-btn>
        </div>
        <div *ngIf="createType === 'Short'">
            <lifedi-btn *ngIf="receiptForm.valid" lable="บันทึก" (click)="saveShortReceipt(receiptForm.value)"
                customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
            </lifedi-btn>
            <lifedi-btn *ngIf="!receiptForm.valid" lable="บันทึก" disabled="true"
                customStyle="margin: 0px; padding: 0 30px;">
            </lifedi-btn>
        </div>
    </div>
    <div *ngIf="isEdit" class="row justify-content-center pb-5 pt-4">
        <lifedi-btn lable="ปิด" (click)="close()"
            customStyle="background-color: #060E9F; color: #FFF; margin: 0px; padding: 0 30px;">
        </lifedi-btn>
    </div>
</div>

<div *ngIf="canPrint">
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME === 'คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย'">
        <lifedi-print-receipt-agency [printDetail]="printDetail"></lifedi-print-receipt-agency>
    </div>
    <div *ngIf="printDetail.printData.detail.ACCOUNTING_NAME !== 'คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย'">
        <lifedi-print-receipt-organization [printDetail]="printDetail"></lifedi-print-receipt-organization>
    </div>
</div>

<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>